/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { Categories as MarketCategories } from 'models/business/Market';

function MarketSelector({
  value,
  onChange,
}) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      aria-label="text alignment"
    >
      {
        Object.values(MarketCategories).map((market) => (
          <ToggleButton
            key={`${market}`}
            value={market}
            aria-label="left aligned"
            onClick={() => onChange(market)}
          >
            {market}
          </ToggleButton>
        ))
      }
    </ToggleButtonGroup>
  );
}

MarketSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

MarketSelector.defaultProps = {
  value: '',
  onChange: () => {},
};

export default MarketSelector;
